import { Link as RouterLink } from "react-router-dom";
import { Link, Box, Typography } from "@mui/material";

const Footer = () => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          flexDirection: "column",
          alignItems: "center",
          padding: "5px",
          backgroundColor: "#EAEAE9",
          borderTop: "1px solid #ccc",
          boxSizing: "border-box",
        }}
      >
        {/* Left logo */}
        <Box>
          <img
            src="/main-logo.png"
            alt="Main Logo"
            style={{ maxWidth: "150px", height: "60px" }}
          />
        </Box>
        <Typography variant="body2" p={0} textAlign="center">
          Copyright ©2025 Banner Day Threads. All Rights Reserved.
        </Typography>
        {/* 
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            height: "60px",
            justifyContent: "space-between",
          }}
        >
          <Link
            component={RouterLink}
            to="/about-us"
            color="inherit"
            underline="hover"
          >
            About Us
          </Link>
          <Link
            component={RouterLink}
            to="/contact-us"
            color="inherit"
            underline="hover"
          >
            Contact Us
          </Link>
        </Box> */}
      </Box>
    </Box>
  );
};
export default Footer;
